import type { RouteObject } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import StoresPage from "@/pages/stores/page";
import StoreDetailPage from "@/pages/stores/StoreDetail";
import ArticlesPage from "@/pages/articles/page";
import ArticleDetailPage from "@/pages/articles/ArticleDetail";
import TopicsPage from "@/pages/topics/page";
import TopicDetailPage from "@/pages/topics/TopicDetail";
import LocationsPage from "@/pages/locations/page";
import LocationDetailPage from "@/pages/locations/LocationDetail";
import AuthorsPage from "@/pages/authors/page";
import AuthorDetailPage from "@/pages/authors/AuthorDetail";
import TagsPage from "@/pages/tags/page";
import TagDetailPage from "@/pages/tags/TagDetail";
import SearchPage from "@/pages/search/page";
import PrivacyPage from "@/pages/privacy/page";
import TermsPage from "@/pages/terms/page";
import PartnersPage from "@/pages/partners/page";
import JoinUsPage from "@/pages/join-us/page";
import FAQPage from "@/pages/faq/page";
import DanshuiMarketEvent from "@/pages/events/DanshuiMarketEvent";
import NccuMakeupEvent from "@/pages/events/NccuMakeupEvent";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <AboutPage /> },
      { path: "stores", element: <StoresPage /> },
      { path: "stores/:slug", element: <StoreDetailPage /> },
      { path: "articles", element: <ArticlesPage /> },
      { path: "articles/:slug", element: <ArticleDetailPage /> },
      { path: "topics", element: <TopicsPage /> },
      { path: "topics/:slug", element: <TopicDetailPage /> },
      { path: "locations", element: <LocationsPage /> },
      { path: "locations/:slug", element: <LocationDetailPage /> },
      { path: "authors", element: <AuthorsPage /> },
      { path: "authors/:slug", element: <AuthorDetailPage /> },
      { path: "tags", element: <TagsPage /> },
      { path: "tags/:slug", element: <TagDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "terms", element: <TermsPage /> },
      { path: "partners", element: <PartnersPage /> },
      { path: "join-us", element: <JoinUsPage /> },
      { path: "faq", element: <FAQPage /> },
      { path: "events/danshui-market-2026", element: <DanshuiMarketEvent /> },
      { path: "events/nccu-makeup-station-2026", element: <NccuMakeupEvent /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;